import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import UserList from "./components/OrganizationUsers";
import OrganizationProfile from "./components/Profile";
import FirmMapper from "./components/FirmMapper";

import Footer from "../../../components/shared/Footer";
import * as APIModels from "../../../models";
import { OrganizationService } from "../../../services/ClientService";

export default function OrganizationEditPage() {
    const { id } = useParams<{ id?: string }>();
    const [organization, setOrganization] = useState(
        new APIModels.Organization()
    );
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        OrganizationService.get({ id: id ?? "" }).then(
            (resp) => {
                if (resp.successful === true && resp.data) {
                    setOrganization(resp.data);
                    console.log("resp id " + JSON.stringify(resp.data));
                } else {
                    setErrorMessage(resp.message ?? "");
                }
            },
            (error) => {
                setErrorMessage(error);
            }
        );
        if (errorMessage) {
            console.log(errorMessage);
            setErrorMessage("");
        }
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Organization Edit</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Organization
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Organization Edit
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-xl-6">
                        <OrganizationProfile organization={organization} />
                    </div>
                    <div className="col-lg-6 col-xl-6">
                        {" "}
                        <FirmMapper
                            organization={organization}
                            organizationId={id!}
                        />
                    </div>
                </div>

                <div className="row">
                    <div
                        style={{ width: "100%" }}
                        className="col-lg-6 col-xl-6"
                    >
                        <UserList organization={organization} />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
